export default "__VITE_ASSET__DVFe9D7F__"